const defaultState = null
const set = (state, action) => action.products

const eCommerceState = { defaultState, set }
export default eCommerceState
